<template>
  <v-container fluid>
    <v-row class="py-7 pa-5" justify="center">
      <div>
        <h1 class="text-center mb-2">{{ getTitle() }}</h1>
        <p class="text-center">{{ getMainSubtitle() }}</p>
      </div>
    </v-row>
    <CollapsedRegister/>
  </v-container>
</template>

<script>
import CollapsedRegister from "@/components/CollapsedRegister";

export default {
  name: "GeneralLanding",
  data() {
    return {
      language: '',
    };
  },
  components: {CollapsedRegister},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let lang = this.$route.query.language;
      this.language = (lang !== undefined) ? lang : 'ES';
    },
    getTitle() {
      return (this.language === 'EN') ? 'Let\'s achieve more targets and fewer stops' : 'Logra más targets y disminuye tus stops';
    },
    getMainSubtitle() {
      return (this.language === 'EN') ? 'Quickly identify your best trading metrics on a 100% cloud journal.' : 'Identifica rápidamente tus mejores métricas de trading en un journal 100% cloud.';
    }
  }
}
</script>

<style scoped>

</style>
